module.exports = __webpack_public_path__ + "static/home_back1-04391130661a008d9b614bb79fe5fed0.png";